module.exports = __webpack_public_path__ + "media/images/iconLockClosed__okGreen-9b443955ec0e0c44b728cca1cb4ee354.png";